// src/config/menuItems.js
import HomeIcon from '@mui/icons-material/Home';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import PetsIcon from '@mui/icons-material/Pets';
import InventoryIcon from '@mui/icons-material/Inventory';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import BuildIcon from '@mui/icons-material/Build';
import SettingsIcon from '@mui/icons-material/Settings';

export const menuItems = [
  { label: "Dashboard", path: "/dashboard", roles: ["user", "admin"], icon: HomeIcon },
  { label: "Admin Panel", path: "/admin", roles: ["admin"], icon: BuildIcon },
  { label: "Medical History", path: "/history", roles: ["user"], icon: ContentPasteSearchIcon },
  { label: "Patients", path: "/patients", roles: ["user"], icon: PetsIcon },
  { label: "Inventory", path: "/inventory", roles: ["user"], icon: InventoryIcon },
  { label: "Reports", path: "/reports", roles: ["user"], icon: ShowChartIcon },
  { label: "Maintenance", path: "/maintenance", roles: ["user"], icon: BuildIcon },
  { label: "Settings", path: "/settings", roles: ["user"], icon: SettingsIcon },
];
